<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import wootConstants from 'dashboard/constants/globals';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  assistantName: {
    type: String,
    default: '',
  },
  conversationId: {
    type: [Number, String],
    required: true,
  },
});

const store = useStore();
const { t } = useI18n();
const currentUser = useMapGetter('getCurrentUser');

const isTakingOver = ref(false);

const bannerTitle = computed(() =>
  t('CONVERSATION.AI_ATTENDING.BANNER_TITLE', {
    assistantName: props.assistantName,
  })
);

const onTakeOver = async () => {
  if (isTakingOver.value) return;
  isTakingOver.value = true;
  try {
    await store.dispatch('toggleStatus', {
      conversationId: props.conversationId,
      status: wootConstants.STATUS_TYPE.OPEN,
    });
    await store.dispatch('assignAgent', {
      conversationId: props.conversationId,
      agentId: currentUser.value.id,
      assigneeType: 'User',
    });
    useAlert(t('CONVERSATION.AI_ATTENDING.TAKEOVER_SUCCESS'));
  } catch (error) {
    useAlert(t('CONVERSATION.AI_ATTENDING.TAKEOVER_ERROR'));
  } finally {
    isTakingOver.value = false;
  }
};
</script>

<template>
  <div
    class="flex flex-col items-center justify-center gap-3 min-h-[8.5rem] px-4 py-6 text-center"
  >
    <p class="flex items-center gap-1.5 mb-0 text-sm text-n-slate-11">
      <span class="flex-shrink-0 size-4 i-lucide-sparkles" />
      {{ bannerTitle }}
    </p>
    <NextButton
      sm
      slate
      faded
      icon="i-lucide-hand"
      class="rounded-full"
      :is-loading="isTakingOver"
      :label="$t('CONVERSATION.AI_ATTENDING.TAKE_OVER')"
      @click="onTakeOver"
    />
    <p class="mb-0 text-xs text-n-slate-10">
      {{ $t('CONVERSATION.AI_ATTENDING.PRIVATE_NOTE_HINT') }}
    </p>
  </div>
</template>
